<template>
    <div class="horizontal-blocker">
        <h1>{{ t ('mobile.no_set_to_display') }}</h1>
    </div>
</template>
<script setup>
    import { useI18n } from "vue-i18n";
    import { useItineraryStore } from '@/stores/itinerary-stores.ts'
    const { t } = useI18n();
</script>
<style scoped lang="scss">
.horizontal-blocker {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;

    h1  {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
    }
}
</style>